import {
  SearchspringFacet,
  SearchspringFacetValue,
} from '../types/searchspring'
import { SearchspringProduct } from '../types/searchspring'
import { UrlManager } from './url_manager'

export class SearchspringUiRenderer {
  static renderProducts(products: SearchspringProduct[]): string {
    if (!products || products.length === 0) {
      return '<p>No products found.</p>'
    }

    return products
      .map((product) => {
        const core = product.mappings?.core || product // Helper fallback

        // Ensure price formatting
        const price =
          typeof core.price === 'number' ? core.price.toFixed(2) : core.price

        return `
        <div class="collection-product">
          <a href="${core.url}" class="collection-product__link">
            ${
              core.imageUrl
                ? `<div class="collection-product__image-wrapper">
                     <img src="${core.imageUrl}" width="400" height="400" class="collection-product__image" loading="lazy" alt="${core.name}" />
                   </div>`
                : ''
            }
            <div class="collection-product__content">
              <p class="collection-product__title">${core.name}</p>
              <p class="collection-product__price">$${price}</p>
            </div>
          </a>
        </div>
      `
      })
      .join('')
  }

  static renderFacets(facets: SearchspringFacet[]): string {
    if (!facets || facets.length === 0) return ''

    const searchParams = new URL(window.location.href).searchParams

    const activeValuesByField: Record<string, string[]> = {}
    searchParams.forEach((value, key) => {
      if (key.startsWith('filter.')) {
        const field = key.replace('filter.', '')
        if (!activeValuesByField[field]) {
          activeValuesByField[field] = []
        }
        activeValuesByField[field].push(value)
      }
    })

    return facets
      .map((facet) => {
        if (!facet.values || facet.values.length === 0) return ''
        const activeValues = activeValuesByField[facet.field!] || []

        const valuesHtml = facet.values
          .map((val: SearchspringFacetValue) => {
            const url = UrlManager.getUrlForToggle(facet.field!, val.value!)
            const isActive = activeValues.includes(val.value!)
            const activeClass = isActive ? 'text-body' : ''

            return `
           <li class="ss-facet-item mb-2">
             <a href="${url}"
                class="ss-facet-link flex items-center gap-2 hover:underline ${activeClass}"
                data-action="click->collection#handleFilterClick"
             >
                <input type="checkbox" ${isActive ? 'checked' : ''} class="pointer-events-none" />
               <span class="ss-facet-label">${val.label}</span>
               <span class="ss-facet-count text-gray-500 text-sm">(${val.count})</span>
             </a>
           </li>
         `
          })
          .join('')

        return `
        <div class="ss-facet-group mb-6">
           <h3 class="ss-facet-title font-bold mb-2">${facet.label ?? facet.field}</h3>
           <ul class="ss-facet-list">
             ${valuesHtml}
           </ul>
        </div>
      `
      })
      .join('')
  }
}
